<h1 class="page-title">{{ 'account.sections.stats' | t }}</h1>
<p class="muted private"><mat-icon>lock</mat-icon>{{ 'club.stats.privateHint' | t }}</p>

@if (loading) {
  <p class="muted">{{ 'account.loading' | t }}</p>
} @else if (error) {
  <p class="error-text">{{error}}</p>
  <button type="button" class="btn-pill btn-pill-outline" (click)="load()">{{ 'account.retry' | t }}</button>
} @else if (stats) {

  <section class="card stat-card">
    <div class="stat-main">
      <h2 class="card-title">{{ 'club.stats.deals' | t }}</h2>
      <strong class="big">{{stats.deals.published}}</strong>
      <span class="muted">{{ 'club.stats.published' | t }}</span>
      @if (stats.deals.pending) {
        <span class="chip pending">{{ 'club.stats.pending' | t: { count: stats.deals.pending } }}</span>
      }
    </div>
    <div class="stat-details">
      <div class="metric"><strong>{{stats.deals.hot}}</strong><span class="muted"><mat-icon>local_fire_department</mat-icon>{{ 'club.stats.hotDeals' | t: { threshold: stats.hotThreshold } }}</span></div>
      <div class="metric"><strong>{{stats.deals.avgScore12m}}°</strong><span class="muted"><mat-icon>show_chart</mat-icon>{{ 'club.stats.avgScore' | t }}</span></div>
      <div class="metric"><strong>{{stats.deals.maxScore}}°</strong><span class="muted"><mat-icon>trending_up</mat-icon>{{ 'club.stats.maxScore' | t }}</span></div>
      <div class="metric"><strong>{{stats.deals.views | number}}</strong><span class="muted"><mat-icon>visibility</mat-icon>{{ 'club.stats.views' | t }}</span></div>
      <div class="metric"><strong>{{stats.deals.partner}}</strong><span class="muted"><mat-icon>handshake</mat-icon>{{ 'club.stats.partnerDeals' | t }}</span></div>
      <div class="metric"><strong>{{stats.deals.commentsReceived}}</strong><span class="muted"><mat-icon>forum</mat-icon>{{ 'club.stats.commentsReceived' | t }}</span></div>
    </div>
  </section>

  <div class="grid-2">
    <section class="card stat-card">
      <div class="stat-main">
        <h2 class="card-title">{{ 'club.stats.comments' | t }}</h2>
        <strong class="big">{{stats.comments.posted}}</strong>
        <span class="muted">{{ 'club.stats.commentsPosted' | t }}</span>
      </div>
      <div class="stat-details single">
        <div class="metric"><strong>{{stats.comments.discussions}}</strong><span class="muted"><mat-icon>forum</mat-icon>{{ 'club.stats.discussions' | t }}</span></div>
      </div>
    </section>

    <section class="card">
      <h2 class="card-title">{{ 'club.stats.community' | t }}</h2>
      <div class="stat-details three">
        <div class="metric"><strong>{{stats.community.friends}}</strong><span class="muted"><mat-icon>group</mat-icon>{{ 'club.stats.friends' | t }}</span></div>
        <div class="metric"><strong>{{stats.community.followers}}</strong><span class="muted"><mat-icon>person_add</mat-icon>{{ 'club.stats.followers' | t }}</span></div>
        <div class="metric"><strong>{{stats.community.favorites}}</strong><span class="muted"><mat-icon>bookmark_border</mat-icon>{{ 'club.stats.favorites' | t }}</span></div>
      </div>
    </section>
  </div>

  <section class="card stat-card">
    <div class="stat-main">
      <h2 class="card-title">{{ 'club.stats.votes' | t }}</h2>
      <strong class="big">{{stats.votes.total}}</strong>
      <span class="muted">{{ 'club.stats.totalVotes' | t }}</span>
    </div>
    <div class="stat-details three">
      <div class="metric"><strong>{{stats.votes.last12m}}</strong><span class="muted"><mat-icon>how_to_vote</mat-icon>{{ 'club.stats.votes12m' | t }}</span></div>
      <div class="metric"><strong>{{stats.votes.hotVoted}}</strong><span class="muted"><mat-icon>whatshot</mat-icon>{{ 'club.stats.hotVoted' | t }}</span></div>
      <div class="metric"><strong>{{stats.votes.categories}}</strong><span class="muted"><mat-icon>category</mat-icon>{{ 'club.stats.categories' | t }}</span></div>
    </div>
  </section>

  <a class="btn-pill btn-pill-outline" routerLink="/compte/badges"><mat-icon>emoji_events</mat-icon>{{ 'club.stats.seeBadges' | t }}</a>
}
